module Meevo.Plugins.AppointmentBook {

    /**
     * Thin Appointment Book wrapper around the shared ProductUsageModalBridgeHelper.
     * Scoped to the AppointmentBook plugin — keeps the bridge injection-free at the
     * call site in AppointmentBookActionsService.
     */
    export class ProductUsageModalBridge {

        static $inject = [
            'meevo.components.common.ProductUsageModalBridgeHelper',
        ];

        constructor(
            private helper: Meevo.Components.Common.ProductUsageModalBridgeHelper,
        ) { }

        open(appointmentServiceId: string, clientDisplayName: string): void {
            this.helper.openModal({
                appointmentServiceId: appointmentServiceId,
                clientDisplayName: clientDisplayName,
            });
        }
    }
}

angular.module('ApptBookApp')
    .service('meevo.plugins.appointmentBook.ProductUsageModalBridge', Meevo.Plugins.AppointmentBook.ProductUsageModalBridge);
